module.exports = __webpack_public_path__ + "img/book-and-glasses.1fc321fd.png";